import { UserProfile } from "../../../model/User/UserProfile";
import { map, Observable } from "rxjs";
import { apiService } from "../../ApiService";
import { ProfileType } from "../../../model";
export interface CreateProfileFormData {
  nickname: string;
  userProfile: ProfileType;
  birthDate?: string;
  avatarId?: string;
  isPinLocked?: boolean;
  pin?: string;
}
export const createFamilyProfile = ({
  nickname,
  birthDate,
  avatarId,
  userProfile,
  isPinLocked,
  pin,
}: CreateProfileFormData): Observable<UserProfile> => {
  return apiService
    .post<{ profile: UserProfile }>({
      path: `v1/family/profiles`,
      requiresAuthPolicy: "user",

      body: {
        nickname,
        birthDate: birthDate !== "" ? birthDate : undefined,
        avatarId,
        userProfile,
        isPinLocked,
        pin,
      },
    })
    .pipe(map(({ profile }) => profile));
};
